'use client'

import { useState } from 'react'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faWarning } from '@fortawesome/free-solid-svg-icons'

export default function CancelRequest({
  isOpen,
  onClose,
  viewingRequest,
  onCancel,
  title,
  message,
  confirmLabel,
  confirmButtonClassName,
}) {
  const defaultTitle = 'Are you sure you want to cancel this referral?'
  const defaultMessage =
    'Cancelling this referral will invalidate the link that has been sent out to the prospective employee. This action cannot be undone and another referral will need to be made if necessary.'
  const defaultConfirmLabel = 'Cancel Referral'
  const defaultConfirmClassName =
    'inline-flex w-full justify-center rounded-md bg-rose-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-rose-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600 sm:col-start-2'

  const resolvedTitle = title || defaultTitle
  const resolvedMessage = message || defaultMessage
  const resolvedConfirmLabel = confirmLabel || defaultConfirmLabel
  const resolvedConfirmClassName = confirmButtonClassName || defaultConfirmClassName

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-[200]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-[200] w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
                <FontAwesomeIcon
                  icon={faWarning}
                  className="h-7 w-7 text-amber-500"
                />
              </div>
              <div className="mt-3 text-center sm:mt-5">
                <DialogTitle
                  as="h3"
                  className="text-lg font-semibold text-gray-900"
                >
                  {resolvedTitle}
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-base text-gray-500">
                    {resolvedMessage}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
              <button
                type="button"
                onClick={() => onCancel()}
                className={resolvedConfirmClassName}
              >
                {resolvedConfirmLabel}
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => onClose()}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
              >
                Close
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
